module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-3-2-8aaffc5224a59fe5880a9dccbc4c7e31.jpg";